import React, { Fragment, useState, useEffect } from "react";
import {
    List,
    ListItemButton,
    ListItemAvatar,
    ListItemText,
    Grid,
    Typography,
    Chip,
    Divider,
    Tooltip,
    Avatar,
    Checkbox,
    CircularProgress,
    Box,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from "@mui/material";
import moment from "moment";
import formatName from "reuseableTable/naming-convention";

const GroupConnectionList = ({
    users,
    selectedUsers,
    setSelectedUsers,
    fetchMoreData,
    hasMore,
    loading,
    searchTerm,
    groupName,
    setGroupName,
    groupModalOpen,
    setGroupModalOpen,
    handleGroupCreate,
}) => {
    // const [orderedUsers, setOrderedUsers] = useState([]);

    const getInitial = (name) => name?.charAt(0)?.toUpperCase() || "?";

    const stringToColor = (str) => {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        const h = hash % 360;
        return `hsl(${h}, 70%, 80%)`;
    };

    const toggleSelect = (userId) => {
        if (selectedUsers.includes(userId)) {
            setSelectedUsers((prev) => prev.filter((id) => id !== userId));
        } else {
            setSelectedUsers((prev) => [...prev, userId]);
        }
    };

    const handleScroll = (e) => {
        const bottom =
            e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        if (bottom && hasMore && !loading) {
            fetchMoreData();
        }
    };

    // console.log(orderedUsers, 'orderedUsers')

    return (
        <Dialog open={groupModalOpen} onClose={() => setGroupModalOpen(false)} fullWidth>
            <DialogTitle>Create Group</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Group Name"
                    fullWidth
                    variant="outlined"
                    value={groupName}
                    onChange={(e) => setGroupName(e.target.value)}
                />
                <Box onScroll={handleScroll} sx={{ maxHeight: 400, overflow: "auto", mt: 2 }}>
                    <List component="nav">
                        {users?.map((user) => (
                            <Fragment key={user.id}>
                                <ListItemButton
                                    sx={{
                                        borderRadius: 2,
                                        padding: "8px 12px",
                                        backgroundColor: "#fff",
                                        "&:hover": {
                                            backgroundColor: "#f5f5f5",
                                        },
                                    }}
                                >
                                    <Checkbox
                                        edge="start"
                                        checked={selectedUsers.includes(user?.friendAlumniId)}
                                        onChange={(e) => {
                                            e.stopPropagation();
                                            toggleSelect(user?.friendAlumniId);
                                        }}
                                        sx={{ mr: 1 }}
                                    />
                                    <Tooltip title={formatName(user?.friendAlumni?.name)}>
                                        <ListItemAvatar>
                                            <Avatar
                                                alt={user?.friendAlumni?.name}
                                                src={
                                                    user?.image?.data
                                                        ? `data:image/*;base64, ${user?.image?.data}`
                                                        : undefined
                                                }
                                                sx={{
                                                    width: 42,
                                                    height: 42,
                                                    mr: 1.5,
                                                    bgcolor: stringToColor(user?.friendAlumni?.name),
                                                    color: "#333",
                                                    fontWeight: 600,
                                                    border: user?.image?.data
                                                        ? "none"
                                                        : `2px solid hsl(${(() => {
                                                            let hash = 0;
                                                            const name = user?.friendAlumni?.name || "";
                                                            for (let i = 0; i < name.length; i++) {
                                                                hash =
                                                                    name.charCodeAt(i) + ((hash << 5) - hash);
                                                            }
                                                            return hash % 360;
                                                        })()}, 70%, 60%)`,
                                                }}
                                            >
                                                {!user?.image?.data && getInitial(user?.friendAlumni?.name)}
                                            </Avatar>
                                        </ListItemAvatar>
                                    </Tooltip>

                                    <ListItemText
                                        primary={
                                            <Grid container alignItems="center" spacing={2}>
                                                <Grid item xs zeroMinWidth>
                                                    <Typography
                                                        variant="body1"
                                                        sx={{
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        {formatName(user?.friendAlumni?.name)}
                                                    </Typography>
                                                </Grid>
                                                {/* <Grid item>
                                                    <Typography
                                                        variant="subtitle2"
                                                        sx={{ color: "text.secondary" }}
                                                    >
                                                        {moment(user?.lastMessageTimeStamp).format("h:mm A")}
                                                    </Typography>
                                                </Grid> */}
                                            </Grid>
                                        }
                                    />
                                </ListItemButton>
                                <Divider sx={{ margin: "8px 0" }} />
                            </Fragment>
                        ))}
                        {loading && (
                            <Box display="flex" justifyContent="center" py={2}>
                                <CircularProgress size={24} />
                            </Box>
                        )}
                    </List>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setGroupModalOpen(false)}>Cancel</Button>
                <Button
                    onClick={handleGroupCreate}
                    variant="contained"
                    disabled={!groupName.trim()}
                >
                    Create
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default GroupConnectionList;
